import React, { useState, useEffect, useCallback } from "react";
import { Popup } from 'devextreme-react/popup';
import { DataGrid, Column, Paging, Pager, LoadPanel, Selection } from 'devextreme-react/data-grid';
import { TextBox, Button } from 'devextreme-react';
import Toolbar, { Item } from "devextreme-react/toolbar";
import AccordionReact from 'devextreme-react/accordion';
const searchpanel = [
    {
      ID: 1,
      Title: 'Search Filters'
    }
  ];
  
const LookupProfilePopup = ({
    openLookupForm,
    closeLookupSearchForm,
    onSearchLookupIds,
    resetLookupForm,
    onLookupFieldChange,
    code,
    description,
    lookupFormName,
    lookupDataList,
    dataGrid,
    onSelectionChanged
}) => {
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const selectionChanged = useCallback(
      (e, tg) => {
        let newItems = [...selectedItems];
        e.removedItems.forEach((item) => {
          const index = newItems.indexOf(item);
          if (index >= 0) {
            newItems.splice(index, 1);
          }
        });
        if (e.addedItems.length) {
          newItems = [...newItems, ...e.addedItems];
        }
        setSelectedItems(newItems);
        setSearchPanelStatus((prevStatus) => {
          const newStatus = !prevStatus;
          return newStatus;
        });
      },
      [selectedItems, setSelectedItems],
    );
    return (
        <Popup
            visible={openLookupForm}
            onHiding={closeLookupSearchForm}
            showCloseButton={true}
            title={`${lookupFormName} Lookup Form`}
            width="80vw"
            height="75vh"
        >
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="after">
                                        <Button onClick={onSearchLookupIds} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button onClick={resetLookupForm} text="Reset" style={{ marginLeft: '10px' }} />
                                    </Item>
                                    <Item location="after">
                                        <Button onClick={closeLookupSearchForm} text="Done" style={{ marginLeft: '10px' }} />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <div>
                                    <form>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="Code-from"
                                                    name="Code"
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Code:"
                                                    defaultValue=""
                                                    value={code}
                                                    onValueChanged={onLookupFieldChange}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Description:"
                                                    name="Description"
                                                    defaultValue=""
                                                    value={description}
                                                    onValueChanged={onLookupFieldChange}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                    </div>
                </div>
            </div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                noDataText="No Data"
                ref={dataGrid}
                dataSource={lookupDataList}
                showBorders={true}
                height={400}
                hoverStateEnabled={true}
                allowColumnResizing={true}
                allowColumnReordering={false}
                rowAlternationEnabled={false}
                onSelectionChanged={onSelectionChanged}
                showRowLines={true}
                showColumnLines={false}
            >
                <LoadPanel enabled={true} />
                <Selection mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                    showNavigationButtons={true}
                />
                <Column dataField="code" caption="Code"></Column>
                <Column dataField="description" caption="Description"></Column>
            </DataGrid>
        </Popup>
    );
};

export default LookupProfilePopup;
